import { Grid, Box, Typography, Button } from "@mui/material";
import { useContext, useState } from "react";
import { MainContext } from "../../../main/context/MainContextProvider";
import { SqlQueryInfo } from "../types";
import {
  copyToClipboard,
  downloadXLSX,
  formatElapsedTime,
  hasData,
  hasTime,
} from "../helpers";
import { Accordion } from "../../../main/components/accordion/Accordion";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import DownloadIcon from "@mui/icons-material/Download";
import Loading from "../../../main/components/Loading";

export default function SqlQueryItem(props: {
  query: SqlQueryInfo;
  toggleExpandQueryInfo: (queryId: string) => void;
  isExpanded: boolean;
  executeQuery: (
    queryId: string,
    setLoading: (loading: boolean) => void
  ) => Promise<void>;
  clearQueryData: (queryId: string) => Promise<void>;
}) {
  const { selectedDashboardUsina: selectedUsina } = useContext(MainContext);

  const [showSql, setShowSql] = useState(true);
  const [showAnalysis, setShowAnalysis] = useState(true);
  const { query, toggleExpandQueryInfo, isExpanded, executeQuery } = props;
  const [loadingResult, setLoadingResult] = useState(false);
  const toggleSql = () => {
    setShowSql(!showSql);
  };
  const toggleAnalysis = () => {
    setShowAnalysis(!showAnalysis);
  };

  const clearQueryData = async (queryId: string) => {
    await props.clearQueryData(queryId);
  };

  const downloadQueryXlsx = async (query: SqlQueryInfo) => {
    if (!query.csvResult) {
      return;
    }
    downloadXLSX(query.csvResult, selectedUsina?.name || "", query.name);
  };

  return (
    <Accordion.Root
      key={query.id}
      sx={{ marginTop: "15px", cursor: "default" }}
    >
      <Accordion.Header
        toggleDetails={() => {
          toggleExpandQueryInfo(query.id);
        }}
        showDetails={isExpanded}
        title={`${query.name}`}
        typographySx={{
          fontSize: { xs: "13px", sm: "16px" },
          width: "50%",
          textAlign: "left",
        }}
      />
      <Accordion.Content
        showDetails={isExpanded}
        sx={{
          maxHeight: "400px",
          overflow: "auto",
          display: "flex",
        }}
      >
        <Grid container spacing={2} display={"flex"} flexDirection={"row"}>
          <Grid item xs={12} sm={6}>
            <Accordion.Root sx={{ marginTop: "15px", cursor: "default" }}>
              <Accordion.Header
                toggleDetails={() => {
                  toggleSql();
                }}
                showDetails={showSql}
                title={`Consulta SQL`}
                typographySx={{
                  fontSize: { xs: "13px", sm: "16px" },
                  width: "50%",
                  textAlign: "left",
                }}
                children={
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <ContentCopyIcon
                      sx={{
                        fontSize: "20px",
                        color: "#FF9F0C",
                        cursor: "pointer",
                      }}
                      onClick={(event) => {
                        event.stopPropagation();
                        copyToClipboard(query.sql);
                      }}
                    />
                    <Typography
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        paddingLeft: "16px",
                        fontSize: "11px",
                        color: "#FF9F0C",
                        cursor: "pointer",
                      }}
                      onClick={(event) => {
                        event.stopPropagation();
                        copyToClipboard(query.sql);
                      }}
                    >
                      Copiar Consulta
                    </Typography>
                  </Box>
                }
              />
              <Accordion.Content
                showDetails={showSql}
                sx={{ maxHeight: "400px", overflow: "auto" }}
              >
                <Box sx={{ padding: "15px" }}>
                  <Typography variant="body1" textAlign={"start"}>
                    {query.sql}
                  </Typography>
                </Box>
              </Accordion.Content>
            </Accordion.Root>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Accordion.Root sx={{ marginTop: "15px", cursor: "default" }}>
              <Accordion.Header
                toggleDetails={() => {
                  toggleAnalysis();
                }}
                showDetails={showAnalysis}
                title={`Informações de Análise`}
                typographySx={{
                  fontSize: { xs: "13px", sm: "16px" },
                  width: "50%",
                  textAlign: "left",
                }}
              />
              <Accordion.Content
                showDetails={showAnalysis}
                sx={{ maxHeight: "400px", overflow: "auto" }}
              >
                {" "}
                {loadingResult ? (
                  <Loading />
                ) : (
                  <>
                    {hasData(query) ? (
                      <Grid
                        sx={{ padding: "15px" }}
                        container
                        display={"flex"}
                        flexDirection={"column"}
                        justifyContent={"center"}
                        alignItems={"start"}
                        alignContent={"start"}
                        gap={2}
                      >
                        <Grid
                          display={"flex"}
                          flexDirection={"column"}
                          gap={1}
                          justifyContent={"center"}
                          alignContent={"start"}
                          alignItems={"start"}
                        >
                          <Typography variant="body2">Resultado:</Typography>
                          {query.csvResult ? (
                            <Grid
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                              gap={2}
                            >
                              <Grid
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                <ContentCopyIcon
                                  sx={{
                                    fontSize: "20px",
                                    color: "#FF9F0C",
                                    cursor: "pointer",
                                  }}
                                  onClick={(event) => {
                                    event.stopPropagation();
                                    copyToClipboard(query.csvResult);
                                  }}
                                />
                                <Typography
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    paddingLeft: "16px",
                                    fontSize: "11px",
                                    color: "#FF9F0C",
                                    cursor: "pointer",
                                  }}
                                  onClick={(event) => {
                                    event.stopPropagation();
                                    copyToClipboard(query.csvResult);
                                  }}
                                >
                                  Copiar Resultado CSV
                                </Typography>
                              </Grid>
                              <Grid
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                <DownloadIcon
                                  sx={{
                                    fontSize: "20px",
                                    color: "#FF9F0C",
                                    cursor: "pointer",
                                  }}
                                  onClick={(event) => {
                                    event.stopPropagation();
                                    downloadQueryXlsx(query);
                                  }}
                                />
                                <Typography
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    paddingLeft: "16px",
                                    fontSize: "11px",
                                    color: "#FF9F0C",
                                    cursor: "pointer",
                                  }}
                                  onClick={(event) => {
                                    event.stopPropagation();
                                    downloadQueryXlsx(query);
                                  }}
                                >
                                  Baixar Resultado
                                </Typography>
                              </Grid>
                            </Grid>
                          ) : (
                            <Typography variant="body2">
                              Obtido resultado vazio
                            </Typography>
                          )}
                        </Grid>
                        {hasTime(query.elapsedExecutionTime) && (
                          <Typography variant="body2">
                            Tempo de Execução:{" "}
                            {formatElapsedTime(query.elapsedExecutionTime)}
                          </Typography>
                        )}
                        {query.error && (
                          <Grid
                            sx={{
                              display: "flex",
                              alignItems: "start",
                              flexDirection: "column",
                            }}
                            gap={1}
                          >
                            <Typography variant="body2" color="error">
                              Erro: {query.error?.exceptionMessage}
                            </Typography>
                            <Grid display={"flex"} flexDirection={"row"}>
                              <ContentCopyIcon
                                sx={{
                                  fontSize: "20px",
                                  color: "#FF9F0C",
                                  cursor: "pointer",
                                  marginLeft: "8px",
                                }}
                                onClick={() =>
                                  copyToClipboard(
                                    `ExceptionMessage: ${query.error?.exceptionMessage} \nStackTrace: ${query.error?.stackTrace}`
                                  )
                                }
                              />
                              <Typography
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  paddingLeft: "16px",
                                  fontSize: "11px",
                                  color: "#FF9F0C",
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  copyToClipboard(
                                    `ExceptionMessage: ${query.error?.exceptionMessage || "Vazio"
                                    } \nStackTrace: ${query.error?.stackTrace || "Vazio"
                                    }`
                                  );
                                }}
                              >
                                Copiar Erro Detalhado
                              </Typography>
                            </Grid>
                          </Grid>
                        )}
                        <Grid
                          sx={{
                            display: "flex",
                            alignItems: "start",
                            flexDirection: "column",
                          }}
                          gap={1}
                        >
                          <Button
                            variant="contained"
                            color="secondary"
                            onClick={() => clearQueryData(query.id)}
                            sx={{ maxWidth: "130px" }}
                          >
                            Limpar Dados
                          </Button>
                        </Grid>
                      </Grid>
                    ) : (
                      <Grid
                        container
                        display={"flex"}
                        flexDirection={"column"}
                        alignContent={"start"}
                      // justifyContent={"center"}
                      >
                        <Typography
                          textAlign={"justify"}
                          variant="body2"
                          marginBottom={1}
                        >
                          Nenhum resultado disponível, clique no botão abaixo
                          para executar a consulta e visualizar os dados
                          gerados.
                        </Typography>
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={async () => {
                            await executeQuery(query.id, setLoadingResult);
                          }}
                          sx={{ maxWidth: "130px" }}
                        >
                          Executar Consulta
                        </Button>
                      </Grid>
                    )}
                  </>
                )}
              </Accordion.Content>
            </Accordion.Root>
          </Grid>
        </Grid>
      </Accordion.Content>
    </Accordion.Root>
  );
}
